import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";
import { ALLOW_UNAPPROVED_BRANDS, ROUTES } from "../../constants";
import { BrandContext } from "../context/BrandContext";
import Loading from "../atoms/Loading";

function BrandRoute() {
  const { brandDetails, brandId, loading } = useContext(BrandContext);

  if (loading) return <Loading />;

  if (!brandId) <Navigate to={ROUTES.BRAND_ONBOARDING} />;

  if (!brandDetails)
    return (
      <div className="flex h-full flex-col items-start justify-center gap-4 pb-60 pl-[20%] text-white">
        <h1 className="flex items-center gap-2 font-sora text-4xl font-medium underline underline-offset-4">
          Unable to fetch Brand Details
          <ExclamationCircleIcon className="h-8 w-8 text-white" />{" "}
        </h1>
        <ul className="mb-1 list-disc space-y-2 pl-5 text-white opacity-80">
          <li>Please check your network connection</li>
          <li>Try reloading the page</li>
        </ul>
      </div>
    );

  return brandDetails.is_approved || ALLOW_UNAPPROVED_BRANDS === "true" ? (
    <Outlet />
  ) : (
    <Navigate to={ROUTES.BRANDS_SIGNUP_SUCCESS} />
  );
}
export default BrandRoute;
